const MAX_CACHE_AGE = 7 * 24 * 60 * 60 * 1000; // 7 days
const IDB_KEY = 'climate-champions-query-idb';

export {
  MAX_CACHE_AGE,
  IDB_KEY,
};